<template>
<v-container fluid class="grey lighten-4">
    <v-layout justify-center column>
        <v-flex flex xs12 sm12 md12 lg12>
            <v-layout v-if="isLocale" justify-center align-center >
                <!--v-flex flex xs12 sm12 md12 lg12>
                    <v-btn round class="red darken-4 white--text" @click="gotoAdmin()">PANNELLO AMMINISTRATORE
                    </v-btn>
                </v-flex-->
            </v-layout>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 class="mb-1" v-if="ids == undefined && !isLocale">
            <table width="100%" border=0 >
                <tr>
                    <td width="33%"> <span  :class="type == 'PRECEDENTI' ? 'liveselector red white--text pa-1' : 'black--text'" @click="filter('PRECEDENTI')"><small>RECENTI</small>
                        </span></td>
                    <td width="33%" align="center"><span  :class="type == 'OGGI' ? 'liveselector red white--text pa-1' : 'black--text'" @click="filter('OGGI')"><small>OGGI</small>
                        </span></td>
                    <td width="33%" align="right"> <span :class="type == 'PROSSIMI' ? 'liveselector red white--text pa-1' : 'black--text'" @click="filter('PROSSIMI')"><small>PROSSIMI</small>
                        </span></td>
                </tr>
            </table>

        </v-flex>

        <v-flex  v-if="isLocale" flex xs12 sm12 md12 lg12>
            <v-data-table no-data-text="Nessun evento attivo" :items="getEvents()" hide-actions hide-headers class="elevation-1 mb-5" style="width: 100%">
                <template slot="items" slot-scope="props">
                    <tr style="height: 50px" class="mb-0 pa-2" >
                        <td class="pa-1">
                            {{ props.item.descrizione }}<br>
                        </td>
                        <td class="pa-1">
                            <v-btn small class="grey darken-3 white--text"  @click="gotoEvento(props.item, 'remoteattivopublic' )"  >STACK</v-btn>
                            <v-btn small class="red darken-3 white--text"  @click="gotoEvento(props.item, 'remoteattivo')" >DASHBOARD</v-btn>
                            <v-btn small class="green darken-3 white--text"  @click="gotoEvento(props.item, 'led')" >LED</v-btn>
                            <v-btn small class="grey lighten-3 black--text"  @click="gotoEvento(props.item, 'remote')" >REMOTE</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex v-else flex xs12 sm12 md12 lg12>
            <v-data-table no-data-text="Nessun evento attivo" :items="getEvents()" hide-actions hide-headers class="elevation-1 mb-5" style="width: 100%">
                <template slot="items" slot-scope="props">
                    <tr style="height: 50px" class="mb-0 pa-2" @click="gotoEvento(props.item)">
                        <td v-if="!isLocale" class="pa-1 no-wrap" style="text-align: center">
                            <strong>{{
                                            props.item.dataEvento
                                        }}</strong>
                        </td>
                        <td class="pa-1">
                            {{ props.item.descrizione }}<br>
                            <span v-if="!isLocale">{{ props.item.DESCR }}</span>
                        </td>
                        <!--td class="pa-1">
                                    <v-icon class="red--text"
                                        >visibility</v-icon
                                    >
                                </td-->
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
    <v-layout v-if="!isLocale" justify-center align-center column>
        <v-flex flex xs12 sm12 md12 lg12>
            <div class="justify-center">
                Accedi al sito icron.it per vedere le classifiche definitive
                dell'evento
            </div>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12>
            <v-btn round class="warning black--text" @click="openNewgo()">CLASSIFICHE
            </v-btn>
        </v-flex>
    </v-layout>
   

</v-container>
</template>

<script>
const moment = require('moment');

export default {
    components: {
    },
    name: 'HomeDetails',
    data: () => ({
        filteredEvents: [],
        tab: null,
        items: ['Eventi Live'],
        version: undefined,
        isLocale: false,
        type: 'OGGI',
        dataOggi: null,
        sport: null,
        ids: null,
    }),
   
    mounted() {
        this.dataOggi = moment(new Date()).format("YYYY-MM-DD");
        this.version = global.helper.ls.get('icronliveversion');
        this.checkFEVersion();

        console.log( this.$route.query)

        this.sport = this.$route.query.sport
        console.log("FILTRO SPORT>" + this.sport)

        this.ids = this.$route.query.ids
        console.log("FILTRO IDS>" + this.ids)

        this.isLocale = this.isLocalEnvironment()


        this.loadEventiLive();

        setInterval(this.loadEventiLive,30000);
    },
    methods: {

        isLocalEnvironment() {
            const hostname = window.location.hostname;

            return (
                hostname === 'localhost' ||
                hostname === '127.0.0.1' ||
                /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)
            );
        },


        gotoEvento: function (evento, liveTemplate= undefined) {
            if (evento.data > this.dataOggi) {
                alert("Evento non ancora iniziato");
                return;
            }

            if (liveTemplate != undefined) {
                evento.TEMPLATE = liveTemplate;
            }

            let _url = 'generic';
            if (evento.TEMPLATE === 'remote') {
                _url = "/remote/" + evento.idGara + "/" + evento.ID;
            } else if (evento.TEMPLATE === 'remoteattivo') {
                _url = "/remoteattivo/" + evento.idGara + "/" + evento.ID;
            } else if (evento.TEMPLATE === 'led') {
                _url = "/led/" + evento.idGara + "/" + evento.ID;
            } else if (evento.TEMPLATE === 'remoteattivopublic') {
                _url = "/remoteattivopublic/" + evento.idGara + "/" + evento.ID;
            } else if (evento.TEMPLATE === 'tzero') {
                _url = "/tzero/" + evento.idGara + "/" + evento.ID;
            } else if (evento.TEMPLATE === 'remoteLaps') {
                _url = "/remoteLaps/" + evento.idGara + "/" + evento.ID + "/local";
            } else if (evento.TEMPLATE === 'remoteTri') {
                _url = "/remoteTri/" + evento.idGara + "/" + evento.ID + "/" + evento.DIV;;
            } else if (evento.TEMPLATE === 'local') {
                _url = "/remote/" + evento.idGara + "/" + evento.ID + "/local";
            } else if (evento.TEMPLATE === 'generic') {
                _url = "/generic/" + evento.idGara + evento.DIV;
            } else if (evento.TEMPLATE === 'ranktri') {
                _url = "/rank/" + evento.idGara + "-" + evento.DIV + "/" + evento.ID + "/TRI";
            } else if (evento.TEMPLATE === 'rankdua') {
                _url = "/rank/" + evento.idGara + "-" + evento.DIV + "/" + evento.ID + "/DUA";
            } else if (evento.TEMPLATE === 'rankaqua') {
                _url = "/rank/" + evento.idGara + "-" + evento.DIV + "/" + evento.ID + "/AQU";
            } else if (evento.TEMPLATE === 'rankwtri') {
                _url = "/rank/" + evento.idGara + "-" + evento.DIV + "/" + evento.ID + "/WTRI";
            } else if (evento.TEMPLATE === 'ultra') {
                _url = "/rank/ultra/" + evento.idGara + "/" + evento.ID;
            } else if (evento.TEMPLATE === 'pasaggiultra') {
                _url = "/passaggi/" + evento.idGara;
            } else if (evento.TEMPLATE === 'link') {
                let _url = evento.ID.replaceAll('§',"="); 
                window.open(_url, '_new');
                return;
            }

            //if (this.isLocale) _url += "/admin=admin123"

            this.$router.push(_url);
        },

        gotoAdmin() {
            this.$router.push("/admin");
        },

        openNewgo() {
            window.open('https://www.icron.it/newgo/#/classifiche', '_new');
        },

        loadEventiLive() {
            const dataInf =  moment(new Date()).subtract(10, "days").format("YYYY-MM-DD");
            const dataSup =  moment(new Date()).add(30, "days").format("YYYY-MM-DD");

            this.getElencoGareLive(dataInf, dataSup).then((response) => {
                console.log(response);
                if (response.esito === 'OK') {
                    /*if (response.messaggio === 'TEMPOZERO') {
                        this.isLocale = true;
                    }*/
                    this.filteredEvents = [];
                    response.listaEventi.forEach(element => {
                        if (this.sport !== undefined && element.sport !== this.sport) {
                            console.log("Applicato filtro: " + this.sport + " - " + element.sport);
                        } else if (this.ids !== undefined && this.ids.indexOf(element.idGara) == -1 ) {
                            console.log("Applicato filtro: " + this.ids + " - " + element.idGara);
                        } else if (!!element.mappaAttributi && !!element.mappaAttributi.LIVE) {
                            //LIVE: "DIV=24H;ID=M;TEMPLATE=generic;DESCR=24 Ore del Levante|DIV=6H;ID=;TEMPLATE=rank;DESCR=6 ore del sole"
                            let data = element.mappaAttributi.LIVE.split("|");
                            data.forEach(garaLive => {
                                let gara = {};
                                let dataTok = element.dataEvento.split("-");
                                gara.dataEvento = dataTok[2] + "/" + dataTok[1];
                                gara.data = element.dataEvento
                                gara.descrizione = element.descrizione;
                                gara.idGara = element.idGara
                                let fields = garaLive.split(";");
                                fields.forEach(field => {
                                    let attrVal = field.split("=");
                                    gara[attrVal[0]] = attrVal[1];
                                });

                                if (this.isLocale) gara.TEMPLATE = 'remoteattivopublic'

                                if (gara.TEMPLATE !== 'trackerconsole') 
                                    this.filteredEvents.push(gara);
                                console.log(gara)
                            });

                        } else if (element.sport === 'RANDONNEE') {
                            let gara = {};
                            let dataTok = element.dataEvento.split("-");
                            gara.dataEvento = dataTok[2] + "/" + dataTok[1];
                            gara.data = element.dataEvento
                            gara.descrizione = element.descrizione;
                            gara.idGara = element.idGara

                            gara.DESCR = "Rando live"
                            gara.DIV = ""
                            gara.ID = gara.idGara
                            gara.TEMPLATE = "random"
                            gara.token = element.config

                            this.filteredEvents.push(gara);
                        }
                    });
                }
            });
        },

        getEvents() {
            if (this.ids !== undefined || this.isLocale) return this.filteredEvents;

            let ev =  this.filteredEvents.filter(elem => {
                if (this.type === 'OGGI') {
                    return elem.data === this.dataOggi
                } else if (this.type === 'PROSSIMI') {
                    return elem.data > this.dataOggi
                } else if (this.type === 'PRECEDENTI') {
                    return elem.data < this.dataOggi
                }
            });

            if (this.type === 'PRECEDENTI') {
                return ev.reverse();
            }

            return ev;


        },

        filter(type) {
            this.type = type;
            this.items[0] = 'LIVE ' + type;
        },

        checkFEVersion() {
            let self = this;
            this.checkVersion({}).then((res) => {
                //console.log(res);
                console.log(
                    'CHECK VERSION:' + self.version + ' - ' + res.version
                );
                if (self.version == undefined) {
                    global.helper.ls.set('icronliveversion', res.version);
                    this.version = res.version;
                } else {
                    if (res.version != self.version) {
                        console.log(
                            'Trovato aggiornamento piattaforma. ' +
                            self.version +
                            ' --> ' +
                            res.version
                        );
                        global.helper.ls.set('icronliveversion', res.version);
                        location.reload(true);
                    }
                }
            });
        },

       
    },
};
</script>

<style scoped>
.liveselector {
    border-radius: 3px;
    font-weight: bold
}
</style>
